import { Callout } from '@/components/ui'
import type { RelatoWifi } from '@/api/robo'

/**
 * Modo rede (spec 2026-09-28-robo-modo-rede, 3.7): o robô sem sinal abre a
 * própria rede com 3 resets seguidos. Só vale para o firmware que relatou a
 * capacidade — o relato já deixa de valer quando o OTA volta para uma imagem
 * sem ela (`wifi_remoto.relato_valido`).
 */
export const temModoRede = (relato: RelatoWifi | null | undefined): boolean =>
  (relato?.capacidades ?? []).includes('modo_rede')

export function ModoRedeSemCabo() {
  return (
    <Callout variant="info" title="Sem cabo">
      Aperte o reset do robô 3 vezes seguidas. O visor mostra a rede e a senha. Conecte o
      computador ou o celular nela, abra 192.168.4.1, escolha a rede daqui e volte para esta
      página.
    </Callout>
  )
}
